export default {
    PtSliderRange: {
        invalidTip: '无效数据或超出数据范围',
    },
};
